// extracted by mini-css-extract-plugin
export var errorIcon = "_ou-1";
export var nameLogo = "_ou-0";